import { render, staticRenderFns } from "./ScreenLayoutSelector.vue?vue&type=template&id=238a15a2&scoped=true"
import script from "./ScreenLayoutSelector.vue?vue&type=script&lang=ts"
export * from "./ScreenLayoutSelector.vue?vue&type=script&lang=ts"
import style0 from "./ScreenLayoutSelector.vue?vue&type=style&index=0&id=238a15a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a15a2",
  null
  
)

export default component.exports